import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import StringCell from "@isceco/widget-library2/basic-elements/List/cell/StringCell";
import StyledCell from "../../components/StaticDetailList/StyledCell";
import DateCell from "@isceco/widget-library2/basic-elements/List/cell/DateCell.js";
import EmailCell from "../../components/StaticDetailList/EmailCell";
import ButtonCell from "@isceco/widget-library2/basic-elements/List/cell/ButtonCell";

export default class BenutzerColumns {

  static getVnbColumns(showInactive, deleteCallback) {
    return [
      BenutzerColumns.EXTID_COLUMN(),
      BenutzerColumns.NACHNAME_COLUMN(),
      BenutzerColumns.VORNAME_COLUMN(),
      BenutzerColumns.EMAIL_COLUMN(),
      BenutzerColumns.CREATED_COLUMN(),
      showInactive ? BenutzerColumns.ARCHIVED_COLUMN() : null,
      BenutzerColumns.DELETE_COLUMN(deleteCallback)
    ].filter(v => v)
  }

  static getGpColumns(showInactive, deleteCallback, editCallback) {
    return [
      BenutzerColumns.EXTID_COLUMN(),
      BenutzerColumns.NACHNAME_COLUMN(),
      BenutzerColumns.VORNAME_COLUMN(),
      BenutzerColumns.EMAIL_COLUMN(),
      BenutzerColumns.CREATED_COLUMN(),
      showInactive ? BenutzerColumns.ARCHIVED_COLUMN() : null,
      BenutzerColumns.BERECHTIGUNG_COLUMN(),
      BenutzerColumns.EDIT_COLUMN(editCallback),
      BenutzerColumns.DELETE_COLUMN(deleteCallback)
    ].filter(v => v)
  }

  static EXTID_COLUMN() {
    return new GenericColumn({
      key: 'extId',
      text: 'table.header.benutzer.extId',
      sortable: true,
      cell: new StyledCell(new StringCell(), BenutzerColumns.ROW_FORMAT)
    })
  }

  static NACHNAME_COLUMN() {
    return new GenericColumn({
      key: 'nachname',
      text: 'table.header.benutzer.nachname',
      sortable: true,
      cell: new StyledCell(new StringCell(), BenutzerColumns.ROW_FORMAT)
    })
  }

  static VORNAME_COLUMN() {
    return new GenericColumn({
      key: 'vorname',
      text: 'table.header.benutzer.vorname',
      sortable: true,
      cell: new StyledCell(new StringCell(), BenutzerColumns.ROW_FORMAT)
    })
  }

  static EMAIL_COLUMN() {
    return new GenericColumn({
      key: 'email',
      text: 'table.header.benutzer.email',
      sortable: true,
      cell: new StyledCell(new EmailCell(), BenutzerColumns.ROW_FORMAT)
    })
  }

  static CREATED_COLUMN() {
    return new GenericColumn({
      weight: 0.5,
      key: 'createdOn',
      text: 'table.header.benutzer.createdOn',
      sortable: true,
      cell: new StyledCell(new DateCell(), BenutzerColumns.ROW_FORMAT)
    })
  }

  static ARCHIVED_COLUMN() {
    return new GenericColumn({
      weight: 0.5,
      key: 'archivedOn',
      text: 'table.header.benutzer.archivedOn',
      sortable: true,
      cell: new StyledCell(new DateCell(), BenutzerColumns.ROW_FORMAT)
    })
  }

  static BERECHTIGUNG_COLUMN() {
    return new GenericColumn({
      key: 'role',
      text: 'table.header.benutzer.berechtigung',
      sortable: true,
      cell: new StyledCell(new StringCell({translate: true}), BenutzerColumns.ROW_FORMAT)
    })
  }

  static DELETE_COLUMN(deleteCallback) {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new ButtonCell({
        icon: 'trash',
        variant: 'danger',
        callback: deleteCallback,
        disabled: row => row.archivedOn
      })
    })
  }

  static EDIT_COLUMN(editCallback) {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new ButtonCell({
        icon: 'pencil alternate',
        callback: editCallback,
        disabled: row => row.archivedOn
      })
    })
  }

  static ROW_FORMAT = row => row.archivedOn ? 'text-decoration: line-through; color: var(--isceco-color-grey-700);' : '';
}
